module.exports = __webpack_public_path__ + "img/email.a2f5c879.svg";